import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { DisassociateDeviceTagPanel } from '../../Components/manage-tags/DisassociateDeviceTagPanel';
import { AssociateDeviceTagPanel } from '../../Components/manage-tags/AssociateDeviceTagPanel';
import { TagKnown } from './TagsTable';
import { UpdateTagNamePanel } from '../../Components/manage-tags/UpdateTagNamePanel';
import { StyledModal } from '../../Components/StyledModal';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomerTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tab-panel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};
const a11yProps = (index: number) => {
  return {
    id: `tab-${index}`,
    'aria-controls': `tab-panel-${index}`,
  };
};

interface UpdateTagNamePanelProps {
  tag: TagKnown;
  isVisible: boolean;
  onClose: () => void | Promise<void>;
  refetch: () => void;
}

export const UpdateTagModal = (props: UpdateTagNamePanelProps) => {
  const { tag, isVisible, onClose, refetch } = props;
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const handleClose = () => {
    refetch();
    setValue(0);
    onClose();
  };

  return (
    <StyledModal
      isOpen={isVisible}
      onRequestClose={onClose}
      label="update-tag-modal"
      style={{
        content: {
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 8,
          minWidth: '35vw',
          minHeight: '350px',
          position: undefined,
        },
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        },
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="update tags tab"
          >
            <Tab label="Update Tag Name" {...a11yProps(0)} />
            <Tab label="Associate Device(s)" {...a11yProps(1)} />
            <Tab label="Dissociate Device(s)" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomerTabPanel index={0} value={value}>
          <UpdateTagNamePanel tag={tag} onClose={handleClose} />
        </CustomerTabPanel>
        <CustomerTabPanel index={1} value={value}>
          <AssociateDeviceTagPanel tag={tag} onClose={handleClose} />
        </CustomerTabPanel>
        <CustomerTabPanel index={2} value={value}>
          <DisassociateDeviceTagPanel onClose={handleClose} tag={tag} />
        </CustomerTabPanel>
      </Box>
    </StyledModal>
  );
};
